// 引入axios
import axios from 'axios'
import {Toast} from '@nutui/nutui' // 传送门 http://nutui.jd.com/#/toast

import router from "../router";
import cache from "../utils/cache"

const baseURL = '/';

axios.defaults.withCredentials = false;

// 创建axios实例
const httpService = axios.create({
    baseURL: baseURL, // url前缀
    //timeout: 10000 // 请求超时时间
});


const $_GET = function (variable) {

    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            if(variable == 'activity_id'){
                return parseInt(pair[1]);
            }
            return pair[1];
        }
    }

    return undefined;
}

const get_activity_id = function () {
    let _key = '__activity_id__';
    let activity_id = $_GET('activity_id');
    if (activity_id) {
        cache.set(_key, activity_id);
        return activity_id;
    } else {
        //需求修改,路由里面没活动ID,即默认为访问平台主活动
        return cache.get('__platform_id__');
    }
}



const is_activity = function(){
    let activity_id = $_GET('activity_id');
    if(activity_id){
        return true;
    }else {
        return false;
    }
}

const getplatform = function (call) {

    let platform_id =  cache.get('__platform_id__');
    if(platform_id && platform_id !== 'undefined'){
        call(platform_id);
    }else{
        axios.get('/m/trade/getplatform',{}).then(res => {
            if(res){
                var platform_id = res.data.data.id;
                cache.set('__platform_id__', platform_id, 36000);

                let data = {
                    data: res.data.data.title,
                    expired: Math.ceil(new Date().getTime() / 1000) + parseInt(36000)
                }
                window.localStorage.setItem('activity_name', JSON.stringify(data));
                document.title = res.data.data.title;

                call(platform_id);
            }else {
               // this.$router.push({ name: 'Empty', query: { error: '平台未开启' } })
            }
        })
    }

}

const get_anchor = function () {

    return window.location.hash;
}

const getCookie = function(name){
    let prefix = name + "=";
    let start = document.cookie.indexOf(prefix);
    console.log(document.cookie)
    if (start == -1) {
        return null;
    }
    let end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
 
    let value = document.cookie.substring(start + prefix.length, end)
    return unescape(value);

}

const getBaseUrl = (env) => {
    let base = {
        production: '/',                            // 生产环境接口地址
        development: 'http://localhost:3000',       // 开发环境接口地址
        test: 'http://localhost:3001',              // 测试地址
    }[env]
    if (!base) {
        base = '/'
    }
    return base
}
var loadingToast, loadingToastTimer;


var loadingFlag = false;

function closeLoading() {
    loadingFlag = false;
}

// request拦截器
httpService.interceptors.request.use(
    config => {
        if (loadingToastTimer) clearTimeout(loadingToastTimer);
        if (loadingFlag) {
            loadingToastTimer = setTimeout(() => {
                loadingToast = Toast.loading();
            }, 500);
        }


        if (config.method.toLocaleUpperCase() === 'GET') {
            config.params['_activity_id'] = get_activity_id();
            config.params['_anchor'] = get_anchor();
        } else {
            //config.data['_activity_id'] = get_activity_id();
            //config.params['_anchor'] = get_anchor();
        }

        return config;
    },
    error => {
        // 请求错误处理
        Promise.reject(error);
    }
)

// respone拦截器
httpService.interceptors.response.use(
    response => {
        //loadingFlag = false;
        if (loadingToastTimer) clearTimeout(loadingToastTimer);
        if (loadingToast) {
            loadingToast.hide()
        }
        // 统一处理状态
        const res = response.data;
        //当前请求接口
        const requestUrl = response.config.url;
        const needLogin = new Array('m/hongbao/hongbao_receive','m/order/add_order');
        //needLogin.indexOf(requestUrl) != -1
        
        if (res.code !== 1) { // 需自定义
            var path = window.location.hash;
            if((path !== '#/' && path.slice(0,3) !=='#/?') || needLogin.indexOf(requestUrl) !== -1){
                if(res.code != 401){
                    Toast.text(res.msg);
                }
                
            }
            // 返回异常[未登录]|跳转控制
            if (res.code == 401) {//登录跳转|未登录code都定义为401
                if((path !== '#/' && path.slice(0,3) !=='#/?') || needLogin.indexOf(requestUrl) !== -1){  //首页不跳转,红包领取需登录
                    window.location.href = res.data;
                }
            }
            // 返回异常[路由丢失]|跳转控制
            if (res.code == 404) {//重要资源请求失败|例:活动不存在、用户不存在
                router.push({name: 'Empty', query: {error: res.msg ? res.msg : '活动未开启'}})

            }
            if (res.code == 302) {//提示后重定向
                router.push({path: res.data});
            }
            if((path !== '#/' && path.slice(0,3) !=='#/?') || needLogin.indexOf(requestUrl) !== -1){
                return Promise.reject({
                    status: res.code,
                    message: res.msg
                });
            }
        } else {
            return response.data.data;
        }
    },
    // 处理处理
    error => {
        loadingFlag = true;
        if (loadingToastTimer) clearTimeout(loadingToastTimer);
        if (loadingToast) {
            loadingToast.hide()
        }
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = '错误请求';
                    break;
                case 401:
                    error.message = '未授权，请重新登录';
                    break;
                case 403:
                    error.message = '拒绝访问';
                    break;
                case 404:
                    error.message = '请求错误,未找到该资源';
                    break;
                case 405:
                    error.message = '请求方法未允许';
                    break;
                case 408:
                    error.message = '请求超时';
                    break;
                case 500:
                    error.message = '服务器端出错';
                    break;
                case 501:
                    error.message = '网络未实现';
                    break;
                case 502:
                    error.message = '网络错误';
                    break;
                case 503:
                    error.message = '服务不可用';
                    break;
                case 504:
                    error.message = '网络超时';
                    break;
                case 505:
                    error.message = 'http版本不支持该请求';
                    break;
                default:
                    error.message = `未知错误${error.response.status}`;
            }
        } else {
            error.message = "连接到服务器失败";
        }
        return Promise.reject(error);
    }
)

/*网络请求部分*/

/*
 *  get请求
 *  url:请求地址
 *  params:参数
 * */
export function get(url, params = {}) {

    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'get',
            params: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function fileUpload(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params,
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

export default {
    get,
    post,
    get_activity_id,
    is_activity,
    fileUpload,
    $_GET,
    closeLoading,
    getplatform,
    getCookie,
}
